/* eslint-disable @typescript-eslint/no-var-requires */
require("./src/scss/styles.scss")

const React = require("react")
const { loadScript } = require("./src/analytics/init")
const { sendPageview } = require("./src/analytics/sendEvent")
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { ThumborConfigured } = require("./src/helpers/thumbor")

// Load GA script
loadScript()

// Turn off the ad feature as soon as users turn declines the marketing cookie
window.addEventListener(
    "CookiebotOnLoad",
    function (e) {
        if (e.currentTarget.Cookiebot.consent.marketing == false) {
            ga("set", "allowAdFeatures", false)
        }
    },
    false
)

// Wraps every page in a component
const wrapper = (props) => {
    return <ThumborConfigured>{props.element}</ThumborConfigured>
}

exports.onRouteUpdate = ({ location }) => {
    // Send pageview event on every route
    const pagePath = location ? location.pathname + location.search + location.hash : undefined
    sendPageview(pagePath)
}
wrapper.displayName = "GatsbyWrapper"

exports.wrapRootElement = wrapper
